import { doc, onSnapshot, serverTimestamp, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../lib/firebase/config';

export interface FloaterTrigger {
  character: string;
  sentBy: string;
  sentByName: string;
  sentAt: Timestamp | null;
  nonce: string;
}

export const FLOATER_PRESETS: Array<{ character: string; label: string }> = [
  { character: '👻', label: 'Halloween ghost' },
  { character: '🎃', label: 'Pumpkin' },
  { character: '🦃', label: 'Thanksgiving' },
  { character: '🎅', label: 'Santa' },
  { character: '⛄', label: 'Snowman' },
  { character: '🎆', label: 'New Year' },
  { character: '💘', label: "Valentine's" },
  { character: '☘️', label: "St. Patrick's" },
  { character: '🐰', label: 'Easter' },
  { character: '🇺🇸', label: 'Fourth of July' },
];

export const DEFAULT_FLOATER = '👻';

const STATE_COLLECTION = 'floaterState';
const TRIGGER_DOC = doc(db, STATE_COLLECTION, 'current');
const CHARACTER_DOC = doc(db, STATE_COLLECTION, 'character');

export async function sendFloater(character: string, sentBy: string, sentByName: string): Promise<void> {
  const trigger: FloaterTrigger = {
    character,
    sentBy,
    sentByName,
    sentAt: serverTimestamp() as unknown as Timestamp,
    nonce: Math.random().toString(36).slice(2, 12),
  };
  await setDoc(TRIGGER_DOC, trigger);
}

export function subscribeToFloater(onTrigger: (t: FloaterTrigger) => void): () => void {
  return onSnapshot(
    TRIGGER_DOC,
    (snap) => {
      if (snap.exists()) onTrigger(snap.data() as FloaterTrigger);
    },
    (err) => console.warn('subscribeToFloater error:', err),
  );
}

export async function setFloaterCharacter(character: string): Promise<void> {
  await setDoc(CHARACTER_DOC, { character, updatedAt: serverTimestamp() });
}

export function subscribeToFloaterCharacter(onChange: (character: string) => void): () => void {
  return onSnapshot(
    CHARACTER_DOC,
    (snap) => onChange((snap.data()?.character as string) || DEFAULT_FLOATER),
    (err) => console.warn('subscribeToFloaterCharacter error:', err),
  );
}
